const avatarChangedEventName = "123zap:user-avatar-changed";

export const diceBearAvataaarsBaseUrl = "https://api.dicebear.com/10.x/avataaars/svg";
export const avatarNoneValue = "__none__";

export const avatarBackgroundColors = ["b6e3f4", "c0aede", "d1d4f9", "ffd5dc", "ffdfbf"];
export const avatarSkinColors = ["614335", "d08b5b", "ae5d29", "edb98a", "ffdbb4", "fd9841", "f8d25c"];
export const avatarHairColors = ["2c1b18", "4a312c", "724133", "a55728", "b58143", "d6b370", "ecdcbf", "e8e1e1", "f59797"];
export const avatarClothesColors = ["262e33", "25557c", "5199e4", "65c9ff", "3c4f5c", "929598", "a7ffc4", "ffafb9", "ff5c5c", "ffffff"];

export const avatarOptionGroups = [
  {
    title: "Base",
    fields: [
      { name: "backgroundColor", label: "Fundo", type: "color", options: avatarBackgroundColors },
      { name: "skinColor", label: "Pele", type: "color", options: avatarSkinColors },
    ],
  },
  {
    title: "Cabelo e acessórios",
    fields: [
      {
        name: "topVariant",
        label: "Tipo de cabelo",
        options: [
          "bigHair",
          "bob",
          "bun",
          "curly",
          "curvy",
          "dreads",
          "dreads01",
          "dreads02",
          "frizzle",
          "fro",
          "froBand",
          "longButNotTooLong",
          "shaggy",
          "shaggyMullet",
          "shortCurly",
          "shortFlat",
          "shortRound",
          "shortWaved",
          "sides",
          "straight01",
          "straight02",
          "straightAndStrand",
          "theCaesar",
          "theCaesarAndSidePart",
          "turban",
          "winterHat1",
          "winterHat02",
          "winterHat03",
          "winterHat04",
        ],
      },
      { name: "hairColor", label: "Cor do cabelo", type: "color", options: avatarHairColors },
      {
        name: "accessoriesVariant",
        label: "Acessório",
        optional: true,
        options: ["kurt", "prescription01", "prescription02", "round", "sunglasses", "wayfarers"],
      },
      { name: "accessoriesColor", label: "Cor do acessório", type: "color", options: avatarClothesColors },
    ],
  },
  {
    title: "Rosto",
    fields: [
      { name: "eyesVariant", label: "Olhos", options: ["default", "happy", "side", "squint", "surprised", "wink", "winkWacky", "closed"] },
      { name: "eyebrowsVariant", label: "Sobrancelha", options: ["default", "defaultNatural", "raisedExcited", "raisedExcitedNatural", "flatNatural", "upDown", "upDownNatural"] },
      { name: "mouthVariant", label: "Boca", options: ["default", "smile", "twinkle", "serious", "concerned", "disbelief", "eating", "grimace"] },
      { name: "facialHairVariant", label: "Barba/bigode", optional: true, options: ["beardLight", "beardMedium", "beardMajestic", "moustacheFancy", "moustacheMagnum"] },
      { name: "facialHairColor", label: "Cor da barba", type: "color", options: avatarHairColors },
    ],
  },
  {
    title: "Roupa",
    fields: [
      { name: "clothesVariant", label: "Roupa", options: ["blazerAndShirt", "blazerAndSweater", "collarAndSweater", "hoodie", "overall", "shirtCrewNeck", "shirtScoopNeck", "shirtVNeck"] },
      { name: "clothesColor", label: "Cor da roupa", type: "color", options: avatarClothesColors },
    ],
  },
];

export const avatarOptionLabels = {
  [avatarNoneValue]: "Nenhum",
  bigHair: "Volume alto",
  bob: "Chanel",
  bun: "Coque",
  curly: "Cacheado",
  curvy: "Ondulado",
  dreads: "Dreads",
  dreads01: "Dreads curto",
  dreads02: "Dreads lateral",
  frizzle: "Crespo curto",
  fro: "Black",
  froBand: "Black com faixa",
  longButNotTooLong: "Longo",
  shaggy: "Bagunçado",
  shaggyMullet: "Mullet",
  shortCurly: "Curto cacheado",
  shortFlat: "Curto baixo",
  shortRound: "Curto redondo",
  shortWaved: "Curto ondulado",
  sides: "Lateral",
  straight01: "Liso 1",
  straight02: "Liso 2",
  straightAndStrand: "Liso com mecha",
  theCaesar: "Caesar",
  theCaesarAndSidePart: "Caesar lateral",
  turban: "Turbante",
  winterHat1: "Gorro 1",
  winterHat02: "Gorro 2",
  winterHat03: "Gorro 3",
  winterHat04: "Gorro 4",
  kurt: "Óculos Kurt",
  prescription01: "Óculos 1",
  prescription02: "Óculos 2",
  round: "Óculos redondo",
  sunglasses: "Óculos escuro",
  wayfarers: "Wayfarer",
  default: "Padrão",
  happy: "Feliz",
  side: "Lateral",
  squint: "Semicerrado",
  surprised: "Surpreso",
  wink: "Piscando",
  winkWacky: "Piscando 2",
  closed: "Fechado",
  defaultNatural: "Natural",
  raisedExcited: "Elevada",
  raisedExcitedNatural: "Elevada natural",
  flatNatural: "Reta natural",
  upDown: "Desigual",
  upDownNatural: "Desigual natural",
  smile: "Sorriso",
  twinkle: "Sorriso leve",
  serious: "Séria",
  concerned: "Preocupada",
  disbelief: "Desconfiada",
  eating: "Comendo",
  grimace: "Forçada",
  beardLight: "Barba leve",
  beardMedium: "Barba média",
  beardMajestic: "Barba cheia",
  moustacheFancy: "Bigode fino",
  moustacheMagnum: "Bigode",
  blazerAndShirt: "Blazer e camisa",
  blazerAndSweater: "Blazer e suéter",
  collarAndSweater: "Suéter",
  hoodie: "Moletom",
  overall: "Macacão",
  shirtCrewNeck: "Camiseta",
  shirtScoopNeck: "Gola ampla",
  shirtVNeck: "Gola V",
};

export const defaultAvatarOptions = {
  accessoriesVariant: "",
  accessoriesColor: "262e33",
  backgroundColor: "d1d4f9",
  clothesVariant: "hoodie",
  clothesColor: "5199e4",
  eyebrowsVariant: "default",
  eyesVariant: "default",
  facialHairVariant: "",
  facialHairColor: "2c1b18",
  hairColor: "2c1b18",
  mouthVariant: "smile",
  skinColor: "edb98a",
  topVariant: "shortRound",
};

const legacyAvatarOptionNames = {
  accessories: "accessoriesVariant",
  clothes: "clothesVariant",
  eyebrows: "eyebrowsVariant",
  eyes: "eyesVariant",
  facialHair: "facialHairVariant",
  mouth: "mouthVariant",
  top: "topVariant",
};

const avatarProbabilityByVariant = {
  accessoriesVariant: "accessoriesProbability",
  facialHairVariant: "facialHairProbability",
};

const allowedAvatarOptionsByField = avatarOptionGroups
  .flatMap((group) => group.fields)
  .reduce((optionsByField, field) => {
    optionsByField[field.name] = field.optional ? ["", ...field.options] : field.options;
    return optionsByField;
  }, {});

export function getUserAvatarSeed(user) {
  return String(user?.id || user?.email || user?.name || "123zap-user").trim();
}

export function normalizeAvatarColor(value) {
  return String(value || "").trim().replace(/^#/, "").toLowerCase();
}

export function getDefaultAvatarConfig(user) {
  return {
    provider: "dicebear",
    style: "avataaars",
    seed: getUserAvatarSeed(user),
    options: { ...defaultAvatarOptions },
  };
}

export function normalizeAvatarConfig(config, user) {
  const fallback = getDefaultAvatarConfig(user);

  if (!config || typeof config !== "object") return fallback;
  const rawOptions = config.options || {};
  const migratedOptions = Object.entries(rawOptions).reduce((options, [key, value]) => {
    options[legacyAvatarOptionNames[key] || key] = value;
    return options;
  }, {});
  const sanitizedOptions = Object.entries(migratedOptions).reduce((options, [key, value]) => {
    const allowedOptions = allowedAvatarOptionsByField[key];

    if (!allowedOptions || allowedOptions.includes(value)) {
      options[key] = value;
    }

    return options;
  }, {});

  return {
    provider: config.provider || fallback.provider,
    style: config.style || fallback.style,
    seed: String(config.seed || "").trim() || fallback.seed,
    options: {
      ...fallback.options,
      ...sanitizedOptions,
    },
  };
}

export function buildDiceBearAvatarUrl(config) {
  const normalizedConfig = normalizeAvatarConfig(config);
  const params = new URLSearchParams({
    radius: "50",
    seed: normalizedConfig.seed,
  });

  Object.entries(normalizedConfig.options || {}).forEach(([key, value]) => {
    const normalized = String(value || "").trim();
    const probabilityName = avatarProbabilityByVariant[key];

    if (!normalized) {
      if (probabilityName) params.set(probabilityName, "0");
      return;
    }

    params.set(key, key.toLowerCase().includes("color") ? normalizeAvatarColor(normalized) : normalized);
    if (probabilityName) params.set(probabilityName, "100");
  });

  return `${diceBearAvataaarsBaseUrl}?${params.toString()}`;
}

export function getStoredAvatarConfig(user) {
  const backendConfig = user?.avatar_config || user?.avatarConfig;
  if (backendConfig && typeof backendConfig === "object") {
    return backendConfig;
  }

  return null;
}

export function subscribeToAvatarChanges(callback) {
  if (typeof window === "undefined") return () => {};

  window.addEventListener(avatarChangedEventName, callback);
  window.addEventListener("storage", callback);

  return () => {
    window.removeEventListener(avatarChangedEventName, callback);
    window.removeEventListener("storage", callback);
  };
}

export function buildUserAvatarUrl(user) {
  const directUrl = String(
    user?.user_avatar_url ||
      user?.userAvatarUrl ||
      user?.avatar_url ||
      user?.avatarUrl ||
      user?.picture_url ||
      user?.pictureUrl ||
      user?.picture ||
      user?.photo_url ||
      user?.photoUrl ||
      ""
  ).trim();
  if (directUrl) return directUrl;

  return buildDiceBearAvatarUrl(normalizeAvatarConfig(getStoredAvatarConfig(user), user));
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error("Não foi possível carregar a imagem do avatar."));
    image.src = src;
  });
}

function canvasToPngDataUrl(image, size = 512) {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  canvas.width = size;
  canvas.height = size;
  context.clearRect(0, 0, size, size);
  context.drawImage(image, 0, 0, size, size);

  return canvas.toDataURL("image/png");
}

export async function imageDataUrlToPngDataUrl(dataUrl) {
  const image = await loadImage(String(dataUrl || ""));
  const size = Math.max(256, Math.min(1024, Math.max(image.naturalWidth || 0, image.naturalHeight || 0) || 512));

  return canvasToPngDataUrl(image, size);
}

export async function avatarConfigToPngDataUrl(config, user) {
  const avatarUrl = buildDiceBearAvatarUrl(normalizeAvatarConfig(config, user));
  const response = await fetch(avatarUrl);

  if (!response.ok) {
    throw new Error("Não foi possível gerar o avatar.");
  }

  const svg = await response.text();
  const objectUrl = URL.createObjectURL(new Blob([svg], { type: "image/svg+xml;charset=utf-8" }));

  try {
    const image = await loadImage(objectUrl);
    return canvasToPngDataUrl(image, 512);
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}

export function applyAvatarResponseToUser(user, response, fallbackConfig) {
  if (!user || !response) return user;

  const avatarUrl = response.avatar_url || response.avatarUrl || response.picture_url || response.pictureUrl || response.picture;
  const avatarConfig = response.avatar_config || response.avatarConfig || fallbackConfig;

  return {
    ...user,
    ...(avatarUrl
      ? {
          avatar_url: avatarUrl,
          picture: avatarUrl,
          picture_url: avatarUrl,
        }
      : {}),
    ...(avatarConfig ? { avatar_config: avatarConfig } : {}),
  };
}
